export function injectScripts() {
    const googleApiKey = process.env.REACT_APP_GOOGLE_KEY;
    const key = process.env.REACT_APP_GOOGLE_TAG_MANAGER_KEY;
    const msClarityKey = process.env.REACT_APP_MS_CLARITY_KEY;
    const linkedinKey = process.env.REACT_APP_LINKEDIN_PARTNER_ID;

    if (key) {
        const head = document.getElementsByTagName("head")[0];
        const js = document.createElement("script");
        js.type = "text/javascript";
        js.src = `https://www.googletagmanager.com/gtag/js?id=${key}`;
        head.appendChild(js);

        window.dataLayer = window.dataLayer || [];
        function gtag() {
            window.dataLayer.push(arguments);
        }
        gtag("js", new Date());
        gtag("config", key);
    }

    if (msClarityKey) {
        (function (c, l, a, r, i, t, y) {
            c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
            t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
            y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
        })(window, document, "clarity", "script", msClarityKey);
        }
    if (linkedinKey) {
        window._linkedin_partner_id = linkedinKey;
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(_linkedin_partner_id);
        (function (l) {
            if (!l) {
            window.lintrk = function (a, b) {
                window.lintrk.q.push([a, b]);
            };
            window.lintrk.q = [];
            }
            var s = document.getElementsByTagName("script")[0];
            var b = document.createElement("script");
            b.type = "text/javascript";
            b.async = true;
            b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
            s.parentNode.insertBefore(b, s);
        })(window.lintrk);
    }
}